import React from "react";
import {Box, Button, Typography} from "@mui/material";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import {useLanguage} from "../LanguageContext";
import {readyToTravel} from "./styles/HomePageStyles";


const PageHeader = ({images, content, setOpen}) => {
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: {xs: "100vh", md: '100vh'},
                overflow: "hidden",
            }}
        >
            <Swiper
                modules={[Autoplay]}
                autoplay={{delay: 3000, disableOnInteraction: false}}
                loop={true}
                style={{width: "100%", height: "100%"}}
            >
                {images.map((src, index) => (
                    <SwiperSlide key={index}>
                        <Box
                            sx={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                backgroundImage: `url(${src})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Overlay Content */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    textAlign: "center",
                    px: {xs: 3, md: 6},
                    zIndex: 2, // Ensure text is above the image
                }}
            >

                <Typography
                    sx={{
                        color: 'white',
                        fontSize: {
                            xs: '45px',
                            sm: '55px',
                            md: '65px',
                            lg: '75px',
                        },
                        letterSpacing: '0rem',
                        fontFamily: 'ButlerLight',
                    }}
                >
                    {t(content.title)}
                </Typography>
                {content.subtitle &&
                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: {
                                xs: '30px',
                                sm: '30px',
                                md: '30px',
                                lg: '30px',
                            },
                            // letterSpacing: '0rem',
                            fontFamily: 'Jost-Regular',
                        }}>
                        {t(content.subtitle)}
                    </Typography>
                }
            </Box>
            {setOpen &&
                <Box
                    sx={{
                        position: 'absolute',
                        top: {
                            xs: '86%',
                            sm: '86%',
                            md: '86%',
                            lg: '86%',
                        },
                        left: {
                            xs: 'calc(50% - 120px)',
                            sm: 'calc(50% - 120px)',
                            md: 'calc(50% - 125px)',
                            lg: 'calc(50% - 125px)',
                        }
                    }}>
                    <Button
                        onClick={() => setOpen(true)}
                        sx={readyToTravel}
                    >
                        {t('button_ready_to_travel').toUpperCase()}
                    </Button>
                </Box>
            }

        </Box>
    );
};

export default PageHeader;
